exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer-container {\n  background-color: rgba(0, 0, 0, 0.75);\n  bottom: 0;\n  color: white;\n  font-family: CooperHewittBook;\n  font-size: 10px;\n  left: 0;\n  padding: 12px 0;\n  position: fixed;\n  text-align: center;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/Footer.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/css/Footer.css
// module chunks = 0